import JobsCrmPipelineAdvanceFiltersFormProps from '../../../../components/filters/models/JobsCrmPipelineAdvanceFiltersFormProps';

export const pipelineEmptyValues: JobsCrmPipelineAdvanceFiltersFormProps = {
  tags: [],
  currentStageCurrentStatusPairs: null,
  relocationPreferences: null,
  locations: [],
  workAuthorization: [],
  source: [],
  commPreferences: [],
  contactAvailability: [],
  noticePeriod: {
    max: 0,
    min: 0,
  },
  salaryRange: undefined,
  candidateJobStatus: '',
};
